import { ApiError, request } from './client';
import type { TrafficQualityData, TrafficQualityResponse } from './types';

// Admin key only: middleware answers 403 to agent keys. `report` is null until bigquery-service
// has copied the analysts' first nightly snapshot.
export async function fetchTrafficQuality(key: string, signal?: AbortSignal): Promise<TrafficQualityData | null> {
  try {
    const response = await request<TrafficQualityResponse>('/api/traffic-quality', { key, signal });
    return response.report;
  } catch (error) {
    if (import.meta.env.DEV && error instanceof ApiError && error.status === 404) return fetchLocalSnapshot(signal);
    throw error;
  }
}

// Local development only, while the middleware it talks to does not have the route yet (404): a
// snapshot exported from the standalone HTML, public/local/traffic-quality.json, kept out of git
// by .gitignore. When it is missing the dev server answers with index.html, which is not JSON,
// so this resolves to null and the page says there is no data. A deployed build never reads it.
export const LOCAL_SNAPSHOT_URL = '/local/traffic-quality.json';

async function fetchLocalSnapshot(signal?: AbortSignal): Promise<TrafficQualityData | null> {
  const response = await fetch(LOCAL_SNAPSHOT_URL, { signal, cache: 'no-store' });
  if (!response.ok || !response.headers.get('content-type')?.includes('json')) return null;
  return (await response.json()) as TrafficQualityData;
}
